import { formatPeriodDisplay } from '@/utils/dateConverter';
import { SpecialCalculationCost } from '@/types/special-calculation-cost';

interface AdminSpecialCalculationCostInfoProps {
  data: SpecialCalculationCost;
}

const CALC_TYPE_LABELS: Record<number, string> = {
  1: '1回○○円　月●回まで',
  2: '1ヵ月上限（限度額）○○円',
  3: '1回○○円　までで 1ヵ月上限（限度額）○○円',
};

const AdminSpecialCalculationCostInfo = ({ data }: AdminSpecialCalculationCostInfoProps) => {
  const fields = [
    {
      label: '保険者',
      value: data.insurer
        ? `${data.insurer.insurer_number_full} ${data.insurer.insurer_name}`
        : String(data.insurer_id),
    },
    { label: '計算種別', value: CALC_TYPE_LABELS[data.calc_type] ?? data.calc_type },
    { label: '負担金', value: data.limit_amount != null ? `${data.limit_amount}` : '' },
    {
      label: '月間上限回数',
      value: data.limit_num_month != null ? `${data.limit_num_month}` : '',
    },
    {
      label: '月間上限金額',
      value: data.limit_amount_month != null ? `${data.limit_amount_month}` : '',
    },
    {
      label: '安い方の負担金を適用',
      value: data.is_adopted_lower_cost ? '適用' : '適用しない',
    },
    {
      label: '適用期間',
      value: formatPeriodDisplay(data.available_from, data.available_to),
    },
  ];

  return (
    <dl className="grid grid-cols-12 gap-y-2 text-sm">
      {fields.map((item, index) => (
        <div key={index} className="contents">
          <dt className="col-span-4 font-semibold">{item.label}</dt>
          <dd className="col-span-8">{item.value ?? ''}</dd>
        </div>
      ))}
    </dl>
  );
};

export default AdminSpecialCalculationCostInfo;
